export default __webpack_public_path__ + "static/carbon-free-neutralizacao-mobile-019daed6ebbee0e4e005941aea7e58c5.jpg";